import React from 'react';
import Blankwrap from '../../hoc/Blankwrap';
import {Container, Row, Col, Image, Card, CardGroup} from 'react-bootstrap';
import './Sectioned.css';
import Contact from '../contact/Contact';
import BrandLogos from '../brand-logos/BrandLogos';

const Sectioned = function(props){

    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    let rowClass;
    if (vw < 576) {
        rowClass="";
    } else {
        rowClass="flow-reverse";
    }

    return(
        <Blankwrap>
            <section className="anchor" id={"home"}/>
            <Container fluid style={{backgroundColor:'rgb(43,43,43)', backgroundImage: "linear-gradient(rgb(43,43,43), rgb(45,45,45), rgb(50,50,50), rgb(55,55,55), rgb(60,60,60), rgb(100,100,100), rgb(180,180,180))", color:'rgb(240,240,240)', paddingTop:"120px"}}>
                <Row style={{width:'80%', margin:'auto', paddingTop:"5rem"}}>
                    <Image fluid className="main-image" src="img/logos/standard-logo-files/original-on-transparent.png"></Image>
                </Row>
                <Row style={{width:'80%', margin:'auto', marginTop:'3rem', paddingBottom:'1rem'}}>
                    <div style={{margin:"auto"}}>
                        <h2 style={{textAlign:'center', margin:'auto'}}>Securing homes and businesses with bespoke solutions</h2>
                        <p style={{marginTop:'1rem'}}>
                            We make securing your home or business easy and simple by designing, installing, commissioning and maintaining a solution to meet your specific requirements.
                        </p>
                    </div>
                </Row>
            </Container>
            <Container fluid style={{height:"6rem", backgroundImage:"linear-gradient(rgb(180,180,180), rgb(255,255,255))"}} />
            <Container fluid bg="bg-light" style={{backgroundColor:"white"}}>

                <section className="anchor" id={"serviceoverview"}/>
                <Row style={{width:'95%', margin:'auto', padding:'2rem 0 1.5rem 0'}}>  
                    <Col md={12} lg={12}>
                        <CardGroup>
                            <Card className="overview-card" style={{borderStyle:"none"}}>
                                <Card.Img variant="top" src="img/overview/intruder.png"/>
                                <Card.Body>
                                    <Card.Text className="overview-text">
                                        Intruder Detection
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <Card className="overview-card" style={{borderStyle:"none"}}>
                                <Card.Img variant="top" src="img/overview/cctv.png"/>
                                <Card.Body>
                                    <Card.Text className="overview-text">
                                        CCTV Systems
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        
                            <Card className="overview-card" style={{borderStyle:"none"}}>
                                <Card.Img variant="top" src="img/overview/padlock.png"/>
                                <Card.Body>
                                    <Card.Text className="overview-text">
                                        Access Control
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <Card className="overview-card" style={{borderStyle:"none"}}>
                                <Card.Img variant="top" src="img/overview/fire-alarm.png"/>
                                <Card.Body>
                                    <Card.Text className="overview-text">
                                        Fire Detection
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </CardGroup>
                    </Col>
                </Row>
            </Container>
            <Container fluid style={{height:"4rem", backgroundImage:"linear-gradient(rgb(255,255,255), rgb(180,180,180))"}} />
            <Container fluid style={{backgroundColor:'rgb(43,43,43)', backgroundImage:"linear-gradient(rgb(180,180,180), rgb(60,60,60), rgb(55,55,55), rgb(50,50,50), rgb(45,45,45), rgb(43,43,43))", color:'rgb(240,240,240)', padding:"2rem 0 3rem 0"}}>
                <Contact/>
            </Container>

            <Container fluid bg="bg-light" style={{backgroundColor:"white"}}>           

                <section className="anchor2" id={"intruderdetection"}/>
                <Row style={{width:'80%', margin:'auto', paddingTop:'3rem'}}>  
                    <h1 style={{textAlign:'center', margin:'auto'}}>Intruder Detection</h1>
                </Row>
                
                <Row className={rowClass} style={{width:'80%', margin:'auto', marginTop:'3rem'}}>
                    <Col xs={12} md={6}>
                        <p className="service-description">
                            Whether you're protecting your home or your business, our intruder detection systems will give you the peace of mind you need.<br/><br/>
                            With our bespoke design service, expert installation and proactive maintenance we can make sure your system is perfect for you.<br/><br/>
                            We integrate industry leading equipment with control panels capable of controlling 8 to 640 zones utilising wired or wireles devices, or a combination of both.<br/><br/>
                            Our intruder detection syetems can be integrated to access control or cctv systems ensuring ultimate safety and security.
                        </p>
                    </Col>
                    <Col xs={12} md={6}>
                        <Image fluid src="img/intruder.jpg"></Image>
                    </Col>
                                            
                    <BrandLogos
                        srcArray = {[
                            "img/supplier-logos/intruder/texecom.jpg",
                            "img/supplier-logos/intruder/ajax.png",
                            "img/supplier-logos/intruder/scantronic.jpg",
                            "img/supplier-logos/intruder/visonic.jpg",
                            "img/supplier-logos/intruder/pyronix.png",
                            "img/supplier-logos/intruder/galaxy.png"
                        ]}
                    />
                    <div className="break-line"></div>
                </Row>
                

                <section className="anchor2" id={"cctv"}/>
                <Row style={{width:'80%', margin:'auto', marginTop:'3rem'}}>  
                    <h1 style={{textAlign:'center', margin:'auto'}}>CCTV Systems</h1>
                </Row>
                <Row style={{width:'80%', margin:'auto', marginTop:'3rem', textAlign:"left"}}>
                    <Col xs={12} md={6}>
                        <p>
                            Use one of our CCTV systems to protect your home or business and you can enjoy the peace of mind that comes with constant surveillance of your premises.<br/><br/>
                            Our systems can be stand alone or connected to an existing network to allow for remote monitoring from a PC or smart device. In areas where no network is available but remote monitoring is required, we can provide a 4G modem and router to allow remote connection.<br/><br/>
                            We can work with a variety of technologies and manufacturers to ensure your bespoke system is right for you. Our professional and expert installations team will ensure your system doesn't miss a thing.<br/><br/>
                            Here are some of our key offerings:
                        </p>
                        <ul>
                            <li>Picture resolutions up to 8MP (4k)</li>
                            <li>PTZ (Pan, Tilt, Zoom) Cameras with up to 4MP images and 200m IR range</li>
                            <li>Up to 360&#176; FOV</li>
                            <li>Various system types available including: Power Over Coax, Transport Video Interface, IP CCTV</li>
                            <li>Remote monitoring via smart device or central monitoring stations</li>
                            <li>Integration with access control systems</li>
                            <li>Recording to hard drive with storage up to 64TB.</li>
                            <li>Large networked systems consisting of multiple recorders using VMS to control a limitless number of cameras.</li>
                        </ul>
                    </Col>
                    <Col xs={12} md={6}>
                        <Image fluid src="img/cctv.jpg"></Image>
                    </Col>  
                    
                    <BrandLogos
                        srcArray = {[
                            "img/supplier-logos/cctv/hik.png",
                            "img/supplier-logos/cctv/avigilon.png",
                            "img/supplier-logos/cctv/samsung.png",
                            "img/supplier-logos/cctv/honeywell.png",
                            "img/supplier-logos/cctv/axis.png"
                        ]}
                    />
                    <div className="break-line"></div>
                </Row>
                
                <section className="anchor2" id={"firealarm"}/>
                <Row style={{width:'80%', margin:'auto', marginTop:'3rem'}}>  
                    <h1 style={{textAlign:'center', margin:'auto'}}>Fire Alarms</h1>
                </Row>
                <Row className={rowClass} style={{width:'80%', margin:'auto', marginTop:'3rem', textAlign:"left"}}>
                    <Col xs={12} md={6}>
                        <p>
                            We design and install a variety of fire alarm systems suitable for any home or business including convential radial systems and addressable panels. 
                            Addressable panels can be networked together to create a system to suit a large commercial or industrial environment.<br/><br/>
                            Our systems can be integrated to an access control system such that escape routes open during an evacuation.<br/><br/>
                            We can also offer disabled refuge systems and disabled w/c alarm systems.<br/><br/>
                            We integrate all types of fire detection devices including :<br/><br/>
                            <ul>
                                <li>Smoke detectors</li>
                                <li>Heat detectors</li>
                                <li>Beam detectors</li>
                                <li>Aspirators</li>
                                <li>Detectors in voids</li>
                                <li>Manual call points</li>
                            </ul>
                        </p>
                    </Col>
                    <Col xs={12} md={6}>
                        <Image fluid src="img/fire-alarm.jpg"></Image>
                    </Col>

                    <BrandLogos
                        srcArray = {[
                            "img/supplier-logos/fire/advanced.jpg",
                            "img/supplier-logos/fire/fike.png",
                            "img/supplier-logos/fire/apollo.png",
                            "img/supplier-logos/fire/ctec.jpg",
                            "img/supplier-logos/fire/hochiki.png",
                            "img/supplier-logos/fire/morley.jpg"
                        ]}
                    />
                    <div className="break-line"></div>
                </Row>
                
                <section className="anchor2" id={"accesscontrol"}/>
                <Row style={{width:'80%', margin:'auto', marginTop:'3rem'}}>  
                    <h1 style={{textAlign:'center', margin:'auto'}}>Access Control</h1>
                </Row>
                <Row  style={{width:'80%', margin:'auto', marginTop:'3rem', paddingBottom:'3rem', textAlign:"left"}}>
                    <Col xs={12} md={6}>
                        <p>
                            Our access control systems are tailored to your specific needs. From the simple control of a single door to a networked system with 1000 doors, we can help you to achieve what you need.
                            With integration to CCTV, Intruder and Fire Alarm systems you can ensure that your access control keeps your building safe without compromising safety during an emergenncy.<br/><br/>
                            We can integrate many different types of reader into our systems including: <br/><br/>
                            <ul>    
                                <li>Proximity Readers</li>
                                <li>HID Readers</li>
                                <li>Pincode Entry</li>
                                <li>Smart Credentials (using a smart phone or watch)</li>
                                <li>Fingerprint Scanners</li>
                                <li>Facial Recognition</li>
                            </ul>
                            We can also provide intercom systems to compliment your access control system including multi-occupancy systems, perfect for a block of flats for example, or a vandal resistant interface.
                            Of course Covid-19 has meant that there is even more emphasis on separation and our new Covid Screens with integrated audio transmission are perfect for keeping you, your staff and your customers safe.

                        </p>
                    </Col>
                    <Col xs={12} md={6}>
                        <Image fluid src="img/access-control.jpg"></Image>                
                    </Col>
                    <BrandLogos
                        srcArray = {[
                            "img/supplier-logos/access/paxton.png",
                            "img/supplier-logos/access/winpak.png",
                            "img/supplier-logos/access/videx.png",
                            "img/supplier-logos/access/fermax.png",
                            "img/supplier-logos/access/hik.png",
                        ]}
                    />
                </Row>
            </Container>
        </Blankwrap>
    )
}

export default Sectioned;